import Components from "../components";
import Rails from "@rails/ujs";

class FaultResolutionToggle extends Components.Base {
  onAllComponentsReady() {
    this.sendFaultStatusMessage();
  }

  bind() {
    this.on("change", "input", () => this.submit());
  }

  submit() {
    this.sendFaultStatusMessage();
    Rails.fire(this.$el.find("form")[0], "submit");
  }

  message() {
    if (this.$el.find("input").is(":checked")) {
      return "We'll alert you if this error happens again.";
    }
    return "We won't alert you again until the error is resolved.";
  }

  sendFaultStatusMessage() {
    return $("body").trigger("fault-status-message:update", {
      message: this.message(),
      source: "FaultResolutionToggle",
      priority: 1,
    });
  }
}

Components.collection.register({
  selector: ".c-fault-resolution-toggle",
  klass: FaultResolutionToggle,
});
